import { DownOutlined } from '@ant-design/icons';
import {
  getGetFrontRichiesteCsvCampiQueryOptions,
  getGetFrontRichiesteGeojsonCampiQueryOptions,
  getPostFrontRichiesteCsvMutationOptions,
  getPostFrontRichiesteGeojsonMutationOptions,
} from '@framework/api-client/api/inquiries-compile/richieste-controller/richieste-controller.ts';
import { type GetFrontRichiesteParams } from '@framework/api-client/api/inquiries-compile/schemas/getFrontRichiesteParams.ts';
import { Dropdown } from '@framework/ui/components/dropdown/Dropdown.tsx';
import { Button, Space } from 'antd';
import React, { useMemo } from 'react';
import { ExportSubmissionFileButton } from './ExportSubmissionFileButton.tsx';
import { FrontofficeExportFileLogic } from './FrontofficeExportFileLogic.ts';

/**
 * Dropdown per l'esportazione lato Frontoffice
 */
export function ExportSubmissionDropdown(props: {
  query: GetFrontRichiesteParams;
}) {
  const { query } = props;

  const menuItems = useMemo(() => {
    const items = [];
    if (FrontofficeExportFileLogic.showExportCsvButton) {
      items.push({
        style: { padding: '0' },
        label: (
          <ExportSubmissionFileButton
            type="csv"
            getMutationOptions={getPostFrontRichiesteCsvMutationOptions}
            getFieldsQueryOptions={getGetFrontRichiesteCsvCampiQueryOptions}
            fileExtension="csv"
            query={query}
            asMenuItem
          />
        ),
        key: 'csv',
      });
    }

    if (FrontofficeExportFileLogic.showExportGeojsonButton) {
      items.push({
        style: { padding: '0' },
        label: (
          <ExportSubmissionFileButton
            type="geojson"
            getMutationOptions={getPostFrontRichiesteGeojsonMutationOptions}
            getFieldsQueryOptions={getGetFrontRichiesteGeojsonCampiQueryOptions}
            fileExtension="json"
            query={query}
            asMenuItem
          />
        ),
        key: 'geojson',
      });
    }
    return items;
  }, [query]);

  // Se abbiamo un solo pulsante, mostriamo direttamente il pulsante stesso
  // senza il dropdown
  if (menuItems.length === 1) {
    return React.cloneElement(menuItems[0].label as JSX.Element, {
      buttonType: 'default',
      asMenuItem: false,
    });
  }

  if (menuItems.length === 0) return null;

  return (
    <Dropdown menu={{ items: menuItems }}>
      <Button>
        <Space>
          Esporta <DownOutlined />
        </Space>
      </Button>
    </Dropdown>
  );
}
